<template>
  <v-app id="vuetify-app">
    <v-container>
      <v-layout row wrap>
          <v-flex xs12>
            <div class="display-1">{{ education.name }}</div>
            <div class="headline">{{ education.tutor }}  <span class="subheading">{{ education.created_at }}</span></div>
          </v-flex>
          <v-flex xs12>
            <video v-if="hasPermissionForVideo()" width="100%" controls>
              <source :src="getVideoUrl()" />
            </video>
            <v-img src="/img/no_permission_for_education.png" v-else />
          </v-flex>
          <v-flex xs12>
            <div class="description">{{ education.description }}</div>
          </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import {EDUCATION_TYPE} from "./libs";
import {mapGetters} from "vuex";

export default {
  props: {
    education: Object,
  },
  methods: {
    getVideoUrl() {
      return `/education/videos/${this.education.id}`;
    },
    shouldBeGranted() {
      return this.education.type === EDUCATION_TYPE;
    },
    hasPermissionForVideo() {
      if (!this.shouldBeGranted()) {
        return true;
      }
      return this.education.roles.includes(this.userRole);
    },
  },
  computed: {
    ...mapGetters(['userRole']),
  },
};
</script>

<style scoped>
.description {
  background-color: inherit;
  border: none;
  font-family: inherit;
  white-space: pre-wrap;
}
</style>
